module.exports = __webpack_public_path__ + "img/producer.c2ed370d.png";